// @ts-nocheck

import React, { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import styled, { css } from 'styled-components';

import { Target } from '../../client';
import { StreamModes } from '../../constants/picture-in-picture';
import usePictureInPicture from '../../hooks/usePictureInPicture';
import { __ } from '../../i18n/l10n';
import BoomBannerContainer from '../../modules/boom/components/BoomBanner/BoomBannerContainer';
import GRBannerContainer from '../../modules/gift-race/components/GRBanner/GRBannerContainer';
import KLBannerContainer from '../../modules/koh-lanta/containers/KLBannerContainer';
import MPBannerContainer from '../../modules/monopoly/containers/MPBannerContainer';
import { selectRuntimeIsWTVEnabled } from '../../selectors/runtime/runtimePrimary.selector';
import { selectUserPrefsShowWTV } from '../../selectors/user/userPrimary.selector';
import { AutoScrollAnchor } from '../../styled-components/shared';
import { Routes } from '../../types/routes';
import { getShouldEnlightOperationsDisplay } from '../../utils/operations';
import MatchRowList from '../MatchRowList';
import NotFoundView from '../NotFoundView';
import PiPPlaceholder from '../PiPPlaceholder';
import TvBarContainer from '../TvBar/TvBarContainer';

const Wrapper = styled.section`
  position: relative;
`;

const StyledPiPPlaceholder = styled(PiPPlaceholder)`
  margin-bottom: 0.5em;
`;

const TvBarWithPlaceholder = () => {
  const { closeStream, isPipCustomActive, startStream, type } = usePictureInPicture();
  const showWTV = useSelector(selectUserPrefsShowWTV);

  const isWTVEnabled = useSelector(selectRuntimeIsWTVEnabled);

  useEffect(() => {
    if (!Target.__MOBILE__) {
      return;
    }
    const needToStartTvStream = isPipCustomActive && type !== StreamModes.TV && showWTV;

    if (isPipCustomActive && !needToStartTvStream) {
      return;
    }

    if (isWTVEnabled && showWTV) {
      startStream({ type: StreamModes.TV });
    } else {
      closeStream();
    }
  }, [closeStream, isPipCustomActive, startStream, showWTV, type, isWTVEnabled]);

  return Target.__MOBILE__ ? (
    isWTVEnabled && (!isPipCustomActive || (isPipCustomActive && type !== StreamModes.TV)) ? (
      <>
        <TvBarContainer />
        <StyledPiPPlaceholder isExpand={showWTV} />
      </>
    ) : null
  ) : null;
};

const bannersSharedStyle = css`
  margin: 0.7em 0.7em 0.4em;

  ${!Target.__MOBILE__
    ? css`
        margin: 10px 10px 0.4em;
      `
    : undefined}
`;

const StyledKLBannerContainer = styled(KLBannerContainer)`
  ${bannersSharedStyle}
`;

const StyledGRBannerContainer = styled(GRBannerContainer)`
  ${bannersSharedStyle}
`;

const StyledMPBannerContainer = styled(MPBannerContainer)`
  ${bannersSharedStyle}
`;

const StyledBoomBannerContainer = styled(BoomBannerContainer)`
  ${bannersSharedStyle}
`;

export const HOME_ROUTE_ANCHOR_ID = 'home-route-anchor';

const RoutesHome = ({
  isLoading,
  isNull,
  isEmpty,
  list,
  askRoute,
  anchorMatchId,
  licence,
  promotionStatus,
  didReceivedUserData,
}) => {
  // On n'affiche pas le carroussel dans le RoutesHomeContainer sur la licence DE car il sera afficher dans le DesktopLayout
  // Sauf en mode mobile. Ou la il faut continuer de l'afficher ici.

  useEffect(() => {
    askRoute(Routes.HOME);
  }, [askRoute]);

  const showOperationBanners = useMemo(
    () => getShouldEnlightOperationsDisplay(licence, promotionStatus, didReceivedUserData),
    [licence, promotionStatus, didReceivedUserData],
  );

  if (isLoading) {
    return null;
  }

  return (
    <Wrapper className="event-list" data-testid="route-home">
      <AutoScrollAnchor data-anchorid="home-route-anchor" />
      <TvBarWithPlaceholder />

      {!isNull && !isEmpty ? (
        <>
          {showOperationBanners ? (
            <>
              <StyledKLBannerContainer />
              <StyledGRBannerContainer />
              <StyledMPBannerContainer />
              <StyledBoomBannerContainer />
            </>
          ) : null}
          <MatchRowList items={list} anchorMatchId={anchorMatchId} largeMissionCard />
        </>
      ) : null}
      {isNull || isEmpty ? <NotFoundView label={__('no events')} /> : null}
    </Wrapper>
  );
};
export default React.memo<typeof Wrapper>(RoutesHome);
